module.exports = __webpack_public_path__ + "img/pro.b9cb65a7.png";